import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const FilterField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FilterLabel = styled.span`
  font-size: 14px;
  color: ${colors.gray700};
`

export const FilterInput = styled.input`
  padding: 8.75px 10.5px;
  border: 1px solid ${colors.gray300};
  border-radius: 8px;
  font-size: 14px;
  color: ${colors.gray900};
  background-color: ${colors.gray200};
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${colors.orange500};
    box-shadow: 0 0 0 3px rgba(255, 105, 0, 0.1);
  }

  &::placeholder {
    color: ${colors.gray500};
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 13px;
  }
`
